import { render } from "./TaskWAISR.vue?vue&type=template&id=7766d62d"
import script from "./TaskWAISR.vue?vue&type=script&lang=js"
export * from "./TaskWAISR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__